import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useWalletDebitsV2 = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.walletDebitsV2, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getWalletDebitsV2(), {
        params,
      });

      const composeResponse = {
        clinics: Object.values(res.data.data.filters.clinics || {}),
        clinicWalletDebits: res.data.data.report.clinic_report,
        providerWalletDebits: res.data.data.report.provider_report,
      };
      return composeResponse;
    },
    options,
  );
};
